(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/TransitionFadeIn"), require("../../components/Skeleton"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/TransitionFadeIn", "../../components/Skeleton"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/TransitionFadeIn"), require("../../components/Skeleton")) : factory(root["../../components/TransitionFadeIn"], root["../../components/Skeleton"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 